import * as React from 'react'
// import MediaQuery from 'react-responsive'

import {
  MentorsSectionWrapper,
  MentorsandStrategicAdvisorsSection,
  MentorsandStrategicAdvisorsHeading,
  MentorsDetailsContainer,
  MentorImage,
  MentorName,
  MentorDesignation,
  MentorContainer
} from './styledComponents'

type Props = {
  mentorsGroupAdvisorsTeamData: Object
}

class MentorsandStrategicAdvisors extends React.Component<Props> {
  render() {
    const { mentorsGroupAdvisorsTeamData } = this.props
    const {
      heading,
      mentorsGroupAdvisorsMembersList
    } = mentorsGroupAdvisorsTeamData

    return (
      <MentorsSectionWrapper id="proyuga-team-mentors">
        <MentorsandStrategicAdvisorsSection>
          <MentorsandStrategicAdvisorsHeading as="h3">
            {heading}
          </MentorsandStrategicAdvisorsHeading>
          <MentorContainer>
            {mentorsGroupAdvisorsMembersList.map(eachMentor => (
              <MentorsDetailsContainer>
                <MentorImage
                  dataSrc={eachMentor.profilePic}
                  alt={eachMentor.name}
                  className="lazyload"
                />
                <MentorName as="article">{eachMentor.name}</MentorName>
                <MentorDesignation as="article">
                  {eachMentor.designation}
                </MentorDesignation>
              </MentorsDetailsContainer>
            ))}
          </MentorContainer>
        </MentorsandStrategicAdvisorsSection>
      </MentorsSectionWrapper>
    )
  }
}

export default MentorsandStrategicAdvisors



// WEBPACK FOOTER //
// ./src/components/TeamNew/MentorsandStrategicAdvisors/index.js